// extracted by mini-css-extract-plugin
module.exports = {"container":"menu_container__2U4bY","item":"menu_item__2N_-R","active":"menu_active__2p-Bn","text":"menu_text__2jJPy","short":"menu_short__z02yl"};